import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1))",
  },
}));
